import { render, staticRenderFns } from "./Home4.vue?vue&type=template&id=616a6a2a&scoped=true&"
import script from "./Home4.vue?vue&type=script&lang=js&"
export * from "./Home4.vue?vue&type=script&lang=js&"
import style0 from "./Home4.vue?vue&type=style&index=0&id=616a6a2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616a6a2a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/h5-web-gold/h5-web-gold/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616a6a2a')) {
      api.createRecord('616a6a2a', component.options)
    } else {
      api.reload('616a6a2a', component.options)
    }
    module.hot.accept("./Home4.vue?vue&type=template&id=616a6a2a&scoped=true&", function () {
      api.rerender('616a6a2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Home4.vue"
export default component.exports